import Teams from './teams'

const networks = {
  mapNetworkTeams(publisher) {
    const { teams: publisherTeams = [] } = publisher

    return (networkTeam) => {
      const { teamCode = networkTeam.code, teamId = networkTeam.id } = networkTeam
      const team = Teams.findTeam(teamId, teamCode, publisherTeams)
      const teamOption = Teams.mapTeamOption(publisher, { ...team, ...networkTeam })

      return { ...publisher, ...networkTeam, ...teamOption }
    }
  },
  mapNetworkToOrganization(organizations) {
    return (nw) => {
      const { organization = {}, team: networkTeams = [] } = nw || {}
      const error = () => {
        const hasOrganizationError = !organization || typeof organization !== 'object' || !organization.code
        const hasTeamsError = !Array.isArray(networkTeams) || !networkTeams.length
        return ((hasOrganizationError || hasTeamsError) && nw) || false
      }
      const success = () => {
        const { code: billingCode } = organization || {}
        const publisher = organizations.find((p) => p.billingCode === billingCode) || {
          billingCode: null,
          name: 'Organization Unknown',
          publisherId: null,
        }

        nw.publisher = {
          isProcessed: true,
          ...publisher,
          dataType: 'network',
          href: `/internal/organization/${billingCode}`,
          operator: 'incl',
          teams: networkTeams.map(this.mapNetworkTeams(publisher)),
          text: publisher.orgName,
          value: publisher.orgName,
        }

        return nw
      }

      return error() || success()
    }
  },
}

export default networks
